import React from "react";
import { Image, LinkBox, Button, Box, Section, Text } from "@quarkly/widgets";
import { Override } from "@quarkly/components";

import articles from "../subpages/_articles_data";
const articleIds = Object.keys(articles);
const firstArticle = articles[articleIds[0]];
const secondArticle = articles[articleIds[1]];

const IndexesLatestArticles = () => (
  <>
    <Section
      padding="60px 0 40px 0"
      quarkly-title="Section_LatestArticles_Title"
    >
      <Box
        md-width="100%"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-width="1px"
        empty-border-style="solid"
        empty-border-color="LightGray"
        width="100%"
        display="flex"
        align-self="auto"
        flex="1 1 0%"
        align-items="center"
        justify-content="center"
        flex-direction="column"
        flex-wrap="no-wrap"
      >
        <Text
          margin="0px 0px 40px 0px"
          color="--light"
          font="--headline2"
          lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
          md-margin="0px 0px 16px 0px"
        >
          Latest Articles
        </Text>
        <Text
          color="--light"
          font="--base"
          lg-font='normal 400 16px/1.5 "Varta", sans-serif'
          margin="0px 0px 0px 0px"
          text-align="left"
        >
          Below are some of the new activities!
        </Text>
        <Box
          md-width="100%"
          empty-min-width="64px"
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
          width="100%"
          align-self="flex-start"
          flex="1 1 0%"
          align-items="center"
          justify-content="center"
          flex-direction="row"
          flex-wrap="no-wrap"
          display="flex"
        >
          <Text
            color="--light"
            font="--base"
            lg-font='normal 400 16px/1.5 "Varta", sans-serif'
            margin="0px 0px 0px 0px"
            text-align="center"
            display="block"
            padding="0px 0px 20px 0px"
            flex="0 0 auto"
          >
            <br />
            (Or, check our all our articles here:{"  "}
          </Text>
          <Button
            color="--light"
            padding="12px 36px 12px 36px"
            background="linear-gradient(180deg,--color-green 0%,#1e1616 100%) 0 0 no-repeat"
            border-radius="32px"
            type="link"
            href="/articles"
            text-decoration-line="initial"
          >
            Articles
          </Button>
          <Text
            color="--light"
            font="--base"
            lg-font='normal 400 16px/1.5 "Varta", sans-serif'
            margin="0px 0px 0px 0px"
            text-align="center"
            display="block"
            padding="0px 0px 20px 0px"
            flex="0 0 auto"
          >
            <br />
            {"  "}){"  "}
          </Text>
        </Box>
      </Box>
    </Section>
    <Section
      padding="40px 0 40px 0"
      md-padding="20px 0 12px 0"
      quarkly-title="Section_LatestArticles_Content"
    >
      <Override
        slot="SectionContent"
        flex-direction="row"
        md-flex-wrap="wrap"
      />
      <Box
        empty-border-color="LightGray"
        padding="0px 20px 0px 0px"
        md-padding="0px 0px 0px 0px"
        md-width="100%"
        empty-min-width="64px"
        empty-border-style="solid"
        width="50%"
        empty-min-height="64px"
        empty-border-width="1px"
        align-items="center"
        display="flex"
        flex-direction="column"
        justify-content="flex-start"
        flex-wrap="no-wrap"
      >
        <LinkBox href={`/articles/${articleIds[0]}`} className="no-underline">
          <Image
            object-fit="cover"
            lg-max-height="230px"
            src={firstArticle.image}
            max-height="400px"
            width="85%"
            height="100%"
            srcSet={`${firstArticle.image} 500w, ${firstArticle.image} 800w, ${firstArticle.image} 1080w, ${firstArticle.image} 1600w, ${firstArticle.image} 2000w, ${firstArticle.image} 2600w, ${firstArticle.image} 3200w`}
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
          <Text
            sm-margin="24px 0px 16px 0px"
            margin="32px 0px 16px 0px"
            font="--lead"
            color="--green"
            lg-font='normal 600 20px/1.5 "Varta", sans-serif'
            md-margin="12px 0px 16px 0px"
          >
            {firstArticle.title}
          </Text>
          <Text
            margin="0px 0px 0px 0px"
            font="--base"
            color="--light"
            text-align="left"
            lg-font='normal 400 16px/1.5 "Varta", sans-serif'
            md-margin="0px 0px 32px 0px"
          >
            {firstArticle.shortDescription}
          </Text>
        </LinkBox>
      </Box>
      <Box
        empty-border-width="1px"
        empty-border-style="solid"
        width="50%"
        md-width="100%"
        md-padding="0px 0px 0px 0px"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-color="LightGray"
        padding="0px 0px 0px 20px"
        align-items="center"
        display="flex"
        flex-direction="column"
        justify-content="flex-start"
        flex-wrap="no-wrap"
      >
        <LinkBox href={`/articles/${articleIds[1]}`} className="no-underline">
          <Image
            src={secondArticle.image}
            max-height="400px"
            width="85%"
            object-fit="cover"
            lg-max-height="230px"
            height="100%"
            srcSet={`${secondArticle.image} 500w, ${secondArticle.image} 800w, ${secondArticle.image} 1080w, ${secondArticle.image} 1600w, ${secondArticle.image} 2000w, ${secondArticle.image} 2600w, ${secondArticle.image} 3200w`}
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
          <Text
            margin="32px 0px 16px 0px"
            font="--lead"
            color="--green"
            lg-font='normal 600 20px/1.5 "Varta", sans-serif'
            md-margin="12px 0px 16px 0px"
            sm-margin="24px 0px 16px 0px"
          >
            {secondArticle.title}
          </Text>
          <Text
            margin="0px 0px 0px 0px"
            font="--base"
            color="--light"
            lg-font='normal 400 16px/1.5 "Varta", sans-serif'
            text-align="left"
          >
            {secondArticle.shortDescription}
          </Text>
        </LinkBox>
      </Box>
    </Section>
  </>
);

export default IndexesLatestArticles;
